var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbqaBackgroundshape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 235 235",
    style: {
      enableBackground: "new 0 0 235 235"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:#FFFFFF;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Path")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x39_997-Saved-out-assets",
    transform: "translate(-126.000000, -940.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M302.1,1174.7h58.6v-117.2c0-64.7-52.5-117.2-117.2-117.2s-117.2,52.5-117.2,117.2 s52.5,117.2,117.2,117.2c21.3,0,41.3-5.7,58.6-15.7V1174.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbqaBackgroundshape);
export default __webpack_public_path__ + "static/media/FBQA_backgroundshape.ed207281c7eff42edfb8faf991b7e627.svg";
export { ForwardRef as ReactComponent };